


















































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {CartStore} from '@/store/modules/cart.store';
import {IMenuOptionChoice, MenuStore} from '@/store/modules/menu.store';
import {WebService} from '@/services/web.service';
import {CurrencyFilter} from '@/filters/currency';
import {IEditChoice} from '@/components/ItemEdit.vue';
import { isEqual } from 'lodash';
import {Helpers} from '@/services/helpers.service';
// @ is an alias to /src

@Component({
	components: {}
})
export default class ChoiceEdit extends Vue {
	@Prop({required: true})
	menuId!: string;

	// @Prop({required: true})
	// optionId!: string | null;

	@Prop({required: true})
	choice!: IEditChoice;

	@Prop({required: true})
	optionId!: string;

	@Prop({default: false})
	showLabels!: boolean;

	@Prop({default: false})
	selectDisabled!: boolean;

	@Prop({default: false})
	selectionType!: 'radio' | 'checkbox';

	private choiceName = '';
	private choicePrice = '$0.00';
	private selected = false;
	private ignoreChanges = false;


	loadingOverlays: {[key: string]: boolean} = {
		name: false,
		selected: false,
		price: false
	};

	showLoading = false;

	created() {
	}


	get isDirty() {
		return !isEqual(this.cleanServerChoice, this.cleanChoice);
	}

	get cleanServerChoice() {
		return {
			choiceId: this.choice.choiceId,
			name: this.choice.name,
			price: this.choice.price,
			selected: this.choice.selected
		};
	}

	get cleanChoice() {
		return {
			choiceId: this.choice.choiceId,
			name: this.choiceName.trim(),
			price: this.cleanChoicePrice,
			selected: this.selected
		};
	}

	get cleanChoicePrice() {
		return Number(this.choicePrice.replace(/[^0-9]/g, ''));
	}

	get canSave() {
		return this.choiceName.trim() !== '';
	}

	@Watch('choice', {immediate: true, deep: true})
	onChoiceChange(current: IEditChoice, old: IEditChoice | undefined) {
		// if(old !== undefined) {
		// 	console.log(current, old);
		// }
		// Fire off an update if this isn't the initial setup and selected was toggled off (the only thing we care about here)
		this.setupChoice(old !== undefined && this.selected && !current.selected);
	}

	setupChoice(forceSave = false) {
		this.$nextTick(() => {
			// console.log('IGNORE START');
			this.ignoreChanges = true;
			this.choiceName = this.choice.name;
			this.selected = this.choice.selected;
			// Something with that .lazy modifier makes this get overridden if I don't
			// just delay till the next tick
			this.choicePrice = CurrencyFilter(this.choice.price);
			this.$nextTick(() => {
				this.ignoreChanges = false;
				if(forceSave) {
					this.saveChoice(forceSave);
				}
				// console.log('IGNORE END');
			});
		});
	}

	async deleteChoice() {
		if(this.choice.choiceId === null) {
			this.$emit('deleteChoice');
		} else {
			if(await this.$bvModal.msgBoxConfirm('Are you sure you want to delete this option?', {
				centered: true,
				okTitle: 'Delete Option'
			})) {
				try {
					this.showLoading = true;
					await WebService.removeChoiceFromOption(this.menuId, this.optionId, this.choice.choiceId);
					this.showLoading = false;
				} catch(e) {
					this.showLoading = false;
					await this.$bvModal.msgBoxOk( 'There was a problem deleting your choice', {
						title: 'Error',
						centered: true,
						okTitle: 'Ok'
					});
				}
			}

		}
	}

	async saveChoice(forceSave = false) {
		if(
			(
				(
					!this.ignoreChanges &&
					this.isDirty
				)
				|| forceSave
			) &&
			this.canSave
		) {
			console.log('Saving Choice');
			if(this.choice.choiceId === null) {
				await this.createChoice();
			} else {
				const diff = Helpers.diff(this.cleanChoice, this.cleanServerChoice);
				const fieldsBeingUpdated = [];
				for(const key in diff) {
					if(key in this.loadingOverlays) {
						fieldsBeingUpdated.push(key);
					}
				}

				await this.updateChoice(fieldsBeingUpdated);

				// alert('Not Implemented');
			}
		}
		this.updateParent();
	}

	async createChoice() {
		try {
			this.loadingOverlays.name = true;
			await WebService.createChoice(this.menuId, this.optionId, this.cleanChoice);
			// errorMessage = 'There was a problem adding your choice to the modifier';
			// await WebService.addChoiceToOption(this.menuId, this.optionId, choiceId);
			this.loadingOverlays.name = false;
		} catch(e) {
			this.loadingOverlays.name = false;
			await this.$bvModal.msgBoxOk('There was a problem creating your choice', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
		}
	}

	async updateChoice(fieldsBeingUpdated: string[]) {
		try {
			fieldsBeingUpdated.forEach((key) => {
				this.loadingOverlays[key] = true;
			});
			if(this.cleanChoice.choiceId !== null) {
				await WebService.updateChoice(this.menuId, this.optionId, {
					choiceId: this.cleanChoice.choiceId,
					name: this.choiceName,
					price: this.cleanChoicePrice,
					selected: this.selected
				});
			}
			fieldsBeingUpdated.forEach((key) => {
				this.loadingOverlays[key] = false;
			});
		} catch(e) {
			fieldsBeingUpdated.forEach((key) => {
				this.loadingOverlays[key] = false;
			});
			await this.$bvModal.msgBoxOk( 'There was a problem updating your choice', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
		}
	}


	updateParent() {
		if(this.isDirty) {
			// console.log('JSON differed', JSON.stringify(this.choice), JSON.stringify(this.cleanChoice));
			this.$emit('update:choice', this.cleanChoice);
		}
	}

}
